













import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name: "MaintenanceForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
  },
  data() {
    return {
      host       : "https://data.taisam.cn",
      maintenance: { fee: "" },
      rules      : { fee : { required: true, message: "请填写场馆软硬件运维费用：", trigger: "blur" } },
    }
  },
  methods: {
    init(data: any) {
      this.$nextTick(() => {
        // 处理运维费用
        this.maintenance.fee = data.maintenance_payment
      })
    },
    submit() {
      const params = { estimate_id: this.id, maintenance_payment: this.maintenance.fee }
      this.$emit("save", params)
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  }
})
